import React, { createContext, useContext, useState, useEffect } from 'react';

// Create the context
const ConfigContext = createContext({
  isDevelopment: false,
  isLocalDevelopment: false,
  isProduction: true,
  environment: 'production'
});

// Provider component
export const ConfigProvider = ({ children }) => {
  const [config, setConfig] = useState({
    isDevelopment: process.env.NODE_ENV === 'development',
    isLocalDevelopment: process.env.NODE_ENV === 'development' && window.location.hostname === 'localhost',
    isProduction: process.env.NODE_ENV === 'production',
    environment: process.env.NODE_ENV || 'production'
  });

  // You can add any dynamic configuration logic here
  useEffect(() => {
    // Example: detect if running in a test environment
    const isTestEnv = process.env.REACT_APP_TEST_ENV === 'true';
    
    if (isTestEnv) {
      setConfig(prev => ({
        ...prev,
        isTestEnvironment: true
      }));
    }
  }, []);

  return (
    <ConfigContext.Provider value={config}>
      {children}
    </ConfigContext.Provider>
  );
};

// Custom hook for using the context
export const useConfig = () => {
  const context = useContext(ConfigContext);
  if (context === undefined) {
    throw new Error('useConfig must be used within a ConfigProvider');
  }
  return context;
};

export default ConfigContext; 